import { Image, View, Text } from '@react-pdf/renderer'

import tableStyles from './tableStyles'

import greenCheck from '../../assets/green_check.png'
import greyX from '../../assets/grey_X.png'

export interface Info {
  costShare: string
  deductibleApplies: boolean
}

type RowProps = {
  service: string
  serviceInfo: Info
  rowIndex: number
}

const Row = ({ service, serviceInfo, rowIndex }: RowProps) => {
  const { costShare, deductibleApplies } = serviceInfo
  return (
    <View
      style={[
        tableStyles.tableRow,
        { backgroundColor: rowIndex % 2 === 0 ? '#F8F9FA' : 'white' }
      ]}
    >
      <View style={tableStyles.serviceCol}>
        <Text style={tableStyles.cellText}>{service}</Text>
      </View>
      <View style={tableStyles.costShareCol}>
        <Text style={tableStyles.cellText}>{costShare}</Text>
      </View>
      <View
        style={[
          tableStyles.deductibleCol,
          {
            height: '100%',
            alignItems: 'center',
            backgroundColor: deductibleApplies ? '#D8F6DF' : undefined,
            paddingLeft: 5
          }
        ]}
      >
        <Image
          style={{
            width: 7,
            height: 7,
            objectFit: 'contain',
            marginRight: 3
          }}
          src={deductibleApplies ? greenCheck : greyX}
        />
        <Text
          style={[
            tableStyles.cellText,
            { color: deductibleApplies ? undefined : '#90979E' }
          ]}
        >
          {deductibleApplies ? 'Yes' : 'No'}
        </Text>
      </View>
    </View>
  )
}

export default Row
